import Request from "./index";

export const getSupplierList = (page: string) =>
Request.get(`supplier/list/?cursor=${page}`);

export const getFreeTrialList = (page: String) => 
Request.get(`supplier/list/?free_trail=True&cursor${page}`);

export const patchSupplierDetails = (id: number, data: any) =>
Request.patch(`supplier/${id}/`, data);